/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import store from '@/store/index'

import { AuthService } from '@/services/auth.service'

export class Http {
  constructor ({ auth, baseUrl }) {
    this.isAuth = auth
    this.instance = axios.create({ baseURL: baseUrl })
    return this.init()
  }

  init () {
    if (this.isAuth) {
      this.instance.interceptors.request.use(request => {
        request.headers.Authorization = `Bearer ${AuthService.getBearer()}`
        if (AuthService.isAccessTokenExpired() && AuthService.hasRefreshToken()) {
          // Todo
          return request
        } else {
          return request
        }
      }, error => {
        return Promise.reject(error)
      })
    }
    this.instance.interceptors.response.use(
      null,
      error => {
        if (
          error.response &&
          error.response.status &&
          [401, 403].includes(error.response.status)
        ) {
          store.dispatch('user/clear')
          store.dispatch('auth/logout')
        }
        return Promise.reject(error)
      }
    )
    return this.instance
  }
}
